/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getUntrackedTips} from '../api'

 export const useQueryGetUntrackedTips = createReactQueryHook('getUntrackedTips', getUntrackedTips)
